// extracted by mini-css-extract-plugin
export default {"container":"CloseAccount_container__YnyFN","contentHeading":"CloseAccount_contentHeading__TqabH","closeAccountButton":"CloseAccount_closeAccountButton__GZ4jN"};